import { render, staticRenderFns } from "./patientPortalDashboardRightBar.vue?vue&type=template&id=6c8a0344&"
import script from "./patientPortalDashboardRightBar.vue?vue&type=script&lang=js&"
export * from "./patientPortalDashboardRightBar.vue?vue&type=script&lang=js&"
import style0 from "./patientPortalDashboardRightBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports